import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
export default function SearchLoading() {
    return (_jsx(LoadingContainer, { children: _jsxs(LoadingContent, { children: [_jsxs(DotsContainer, { children: [_jsx(Dot1, {}), _jsx(Dot2, {}), _jsx(Dot3, {})] }), _jsx(LoadingText, { children: "\uAC80\uC0C9 \uC911..." })] }) }));
}
// Styled Components
const LoadingContainer = styled.View `
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;
const LoadingContent = styled.View `
  align-items: center;
  gap: 16px;
`;
const DotsContainer = styled.View `
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const baseDotStyle = `
  width: 12px;
  height: 12px;
  background-color: #007aff;
  border-radius: 6px;

  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }

  animation: bounce 1.4s ease-in-out infinite both;
`;
const Dot1 = styled.View `
  ${baseDotStyle}
  animation-delay: 0s;
`;
const Dot2 = styled.View `
  ${baseDotStyle}
  animation-delay: 0.2s;
`;
const Dot3 = styled.View `
  ${baseDotStyle}
  animation-delay: 0.4s;
`;
const LoadingText = styled.Text `
  font-size: 16px;
  color: #666666;
  text-align: center;
`;
